<div class="gw-p-6 gw-space-y-4">
  <h2 class="gw-text-lg gw-font-semibold gw-text-text-primary">
    {{ 'features.communications.sendMessageTest' | translate }}
  </h2>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="gw-space-y-2">
      <label
        for="testPhoneInput"
        class="gw-text-sm gw-font-medium gw-text-text-primary"
      >
        {{ 'features.communications.enterMessage' | translate }}
      </label>
      <small class="gw-block gw-text-xs gw-text-text-secondary">
        {{ 'features.communications.phoneFormat' | translate }}
      </small>
      <tui-textfield class="gw-w-full" tuiTextfieldSize="m">
        <input
          tuiTextfield
          id="testPhoneInput"
          type="text"
          formControlName="phone"
          [placeholder]="'00 (00) 00000-0000'"
          mask="00 (00) 00000-0000"
          [dropSpecialCharacters]="true"
        />
      </tui-textfield>
    </div>
    <div class="gw-flex gw-justify-end gw-gap-2 gw-pt-4">
      <button type="button" tuiButton appearance="secondary" (click)="cancel()">
        {{ 'features.communications.buttons.close' | translate }}
      </button>
      <button
        type="submit"
        tuiButton
        appearance="primary"
        [disabled]="form.invalid"
      >
        {{ 'features.communications.buttons.send' | translate }}
      </button>
    </div>
  </form>
</div>
